import React from 'react';
// import 'react-phone-number-input/style.css';
// import PhoneInput, { Country } from 'react-phone-number-input';
import PhoneInput, { Country } from 'react-phone-number-input/input';

type PhoneNumberInputProps = {
  className?: string;
  name: string;
  id?: string;
  disabled?: boolean;
  error?: boolean;
  onBlur?: () => void;
  defaultCountry?: Country;
  placeholder?: string;
  value: string;
  onChange: (value: any) => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
};

function PhoneNumberInput({
  className,
  name,
  id,
  disabled,
  error,
  onBlur,
  defaultCountry,
  placeholder,
  value,
  onChange,
  onKeyPress,
}: PhoneNumberInputProps) {
  return (
    <PhoneInput
      className={`${className} ${error ? 'border-river-red' : ''}`}
      onBlur={onBlur}
      name={name}
      id={id}
      disabled={disabled}
      country={defaultCountry}
      international
      withCountryCallingCode
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onKeyPress={onKeyPress}
    />
  );
}

PhoneNumberInput.defaultProps = {
  className: '',
  defaultCountry: 'US',
  placeholder: '',
  disabled: false,
  error: false,
  onBlur: undefined,
  id: undefined,
  onKeyPress: undefined,
};

export default PhoneNumberInput;
